module.exports = __webpack_public_path__ + "static/img/no3.aeef9f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bannerbottom/no3.png
// module id = 3v+2
// module chunks = 31